import * as Toast from '@radix-ui/react-toast'
import { styled, keyframes } from '@stitches/react'

const VIEWPORT_PADDING = 25

export const ToastViewport = styled(Toast.Viewport, {
	position: 'fixed',
	bottom: 0,
	right: 0,
	display: 'flex',
	flexDirection: 'column',
	margin: VIEWPORT_PADDING,
	gap: 10,
	width: 438,
	height: 92,
	maxWidth: '100vw',
	listStyle: 'none',
	zIndex: '10000',
	outline: 'none',
})

const hide = keyframes({
	'0%': { opacity: 1 },
	'100%': { opacity: 0 },
})

const slideIn = keyframes({
	from: { transform: `translateX(calc(100% + ${VIEWPORT_PADDING}px))` },
	to: { transform: 'translateX(0)' },
})

const swipeOut = keyframes({
	from: { transform: 'translateX(var(--radix-toast-swipe-end-x))' },
	to: { transform: `translateX(calc(100% + ${VIEWPORT_PADDING}px))` },
})

export const ToastRoot = styled(Toast.Root, {
	backgroundColor: '$green',
	borderRadius: 6,
	boxShadow:
		'hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px',
	padding: '30px 35px',
	height: '100%',
	display: 'grid',
	gridTemplateAreas: '"icon title close"',
	gridTemplateColumns: 'max-content auto max-content',
	columnGap: 15,
	alignItems: 'center',

	'&[data-state="open"]': {
		animation: `${slideIn} 150ms cubic-bezier(0.16, 1, 0.3, 1)`,
	},
	'&[data-state="closed"]': {
		animation: `${hide} 100ms ease-in`,
	},
	'&[data-swipe="move"]': {
		transform: 'translateX(var(--radix-toast-swipe-move-x))',
	},
	'&[data-swipe="cancel"]': {
		transform: 'translateX(0)',
		transition: 'transform 200ms ease-out',
	},
	'&[data-swipe="end"]': {
		animation: `${swipeOut} 100ms ease-out`,
	},
})
export const ToastCheck = styled(Toast.Action, {
	gridArea: 'icon',
})

export const ToastTitle = styled(Toast.Title, {
	gridArea: 'title',
	fontWeight: 500,
	color: '$text',
	fontSize: 20,
})

export const ToastAction = styled(Toast.Close, {
	gridArea: 'close',
	cursor: 'pointer',
})
